module.exports = __webpack_public_path__ + "img/logo.2a50350e.svg";